import { Injectable } from '@angular/core';
import { ProductCode } from './product-code.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface ProductCodeState extends EntityState<ProductCode> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'product-code', idKey: 'ProductCode' })
export class ProductCodeStore extends EntityStore<ProductCodeState> {

  constructor() {
    super();
  }

}

